// プレビュー画面の遷移元モード（URL クエリ ?from= で受け渡し）
// 表示機能とログ記録の出し分けに使う（spec: テスト=markTested のみ /
// マイピース=記録なし / みんなのピース=playPiece 記録 + リアクション操作可）。
export enum PreviewMode {
  TEST = "test", // ビルダー編集画面の「テスト」
  MINE = "mine", // トップ一覧マイピースの「あそぶ」
  PUBLIC = "public", // トップ一覧みんなのピースの「あそぶ」
}

// 不正値・欠落時は書き込みゼロで安全な MINE に倒す
export const parsePreviewMode = (raw: string | null): PreviewMode =>
  (Object.values(PreviewMode) as string[]).includes(raw ?? "")
    ? (raw as PreviewMode)
    : PreviewMode.MINE;
